import { AuthGuard } from "./auth.guard";
import { IsLoggedInGuard } from "./is-logged-in.guard";

export const CORE_GUARDS = [AuthGuard, IsLoggedInGuard];
